var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dfr cross-center fs36 fc333"},[_c('div',{staticClass:"title-left"}),_c('div',{staticClass:"title fb",style:(("font-size:" + _vm.fontSize + ";color:" + _vm.color + ";"))},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }